import { render, staticRenderFns } from "./_by-produto.table.vue?vue&type=template&id=a37496fc&scoped=true"
import script from "./_by-produto.table.vue?vue&type=script&lang=js"
export * from "./_by-produto.table.vue?vue&type=script&lang=js"
import style0 from "./_by-produto.table.vue?vue&type=style&index=0&id=a37496fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a37496fc",
  null
  
)

export default component.exports